import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/telegram.svg'
import _imports_1 from '@/assets/svg/vk.svg'
import _imports_2 from '@/assets/svg/icon_mail.svg'
import _imports_3 from '@/assets/svg/whatsapp.svg'
import _imports_4 from '@/assets/images/league.png'
import _imports_5 from '@/assets/images/touroperators.png'
import _imports_6 from '@/assets/images/mir.png'
import _imports_7 from '@/assets/images/visa.png'
import _imports_8 from '@/assets/images/mastercard.png'


const _withScopeId = n => (_pushScopeId("data-v-26f87eea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contacts mb-[60px] l:px-[216px] justify-center" }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-row gap-x-4"
}
const _hoisted_3 = { href: "#" }
const _hoisted_4 = { href: "#" }
const _hoisted_5 = { class: "flex flex-col xxl:flex-row items-center gap-x-3" }
const _hoisted_6 = {
  href: "mailto:reserv@rvm-spb.ru",
  class: "flex flex-row items-center"
}
const _hoisted_7 = { class: "px-[15px] py-[10px]" }
const _hoisted_8 = {
  href: "tel:+79112660098",
  class: "flex flex-row items-center"
}
const _hoisted_9 = { class: "px-[15px] py-[10px]" }
const _hoisted_10 = { class: "flex flex-col gap-y-5 px-10 mb-12 l:flex-row l:flex-wrap l:gap-x-9 l:px-[216px] l:py-[20px] l:mb-[20px] l:justify-center" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-row gap-x-6 px-[216px] mb-[60px]"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "svg"
  })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "svg"
  })
], -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "flex flex-col justify-center items-center l:flex-row l:px-[216px] l:mb-[60px]" }
const _hoisted_16 = { class: "flex flex-row gap-x-10 mb-6 l:gap-x-12 l:mb-0" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://tourism.gov.ru/reestry/reestr-turoperatorov/show.php?id=101651",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "w-[121px] m:w-auto"
  })
], -1))
const _hoisted_18 = {
  key: 0,
  class: "flex flex-row gap-x-5 mb-10"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "w-[46px] m:h-9 m:w-auto"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "w-[46px] m:h-9 m:w-auto"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "w-[46px] m:h-9 m:w-auto"
}, null, -1))
const _hoisted_22 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "p-[10px] l:ml-auto l:p-0 l:mb-0" }
const _hoisted_24 = { class: "flex flex-col justify-center items-center mb-6 l:flex-row l:px-[216px] l:mb-[60px]" }
const _hoisted_25 = { class: "p-[10px] order-2 m:-order-1" }
const _hoisted_26 = {
  key: 0,
  class: "flex flex-row gap-x-5 l:ml-auto order-0 l:-order-none"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "w-[46px] l:h-9 l:w-auto"
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "w-[46px] l:h-9 l:w-auto"
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "w-[46px] l:h-9 l:w-auto"
}, null, -1))
const _hoisted_30 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]

import { computed } from 'vue';
import { useWindowSize } from '@vueuse/core';
import BaseTypography from './common/BaseTypography.vue';
import { useI18n } from 'vue-i18n';
import BaseButton from './common/BaseButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseFooter',
  setup(__props) {

const { width } = useWindowSize();
const { t } = useI18n();

const currentYear = new Date().getFullYear();

const links = computed(() => [
    {
        url: '/about',
        text: t('footer.links.about'),
    },
    {
        url: '/categories',
        text: t('footer.links.tours'),
    },
    {
        url: '/excursions',
        text: t('footer.links.excursions'),
    },
    {
        url: '/how',
        text: t('footer.links.how'),
    },
    {
        url: '/policy',
        text: t('footer.links.policy'),
    },
    {
        url: '/agents',
        text: t('footer.links.agents'),
    },
    {
        url: '/requisites',
        text: t('footer.links.requisites'),
    },
]);

const openLinkInNewTab = (url: string) => {
    window.open(url, '_blank');
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(width) > 1024)
        ? (_openBlock(), _createBlock(BaseButton, {
            key: 0,
            text: _unref(t)('footer.contacts'),
            type: "body2",
            color: "var(--primary-color)",
            ui: "primary"
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      (_unref(width) < 1024)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("a", _hoisted_3, [
              _createElementVNode("img", {
                src: _imports_0,
                class: _normalizeClass({ svg: _unref(width) >= 768, 'w-7': _unref(width) < 768 })
              }, null, 2)
            ]),
            _createElementVNode("a", _hoisted_4, [
              _createElementVNode("img", {
                src: _imports_1,
                class: _normalizeClass({ svg: _unref(width) >= 768, 'w-7': _unref(width) < 768 })
              }, null, 2)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", _hoisted_6, [
          _createElementVNode("img", {
            src: _imports_2,
            class: _normalizeClass({ 'order-2 w-7': _unref(width) < 768, svg: _unref(width) > 768 })
          }, null, 2),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BaseTypography, {
              text: "reserv@rvm-spb.ru",
              type: _unref(width) < 768 ? 'body2-m' : 'body2'
            }, null, 8, ["type"])
          ])
        ]),
        _createElementVNode("a", _hoisted_8, [
          _createElementVNode("img", {
            src: _imports_3,
            class: _normalizeClass({ 'order-2 w-7': _unref(width) < 768, svg: _unref(width) > 768 })
          }, null, 2),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(BaseTypography, {
              text: "+7 (911) 266-00-98",
              type: _unref(width) < 768 ? 'body2-m' : 'body2'
            }, null, 8, ["type"])
          ])
        ])
      ])
    ]),
    _createElementVNode("ul", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (link) => {
        return (_openBlock(), _createElementBlock("li", {
          key: link.url
        }, [
          _createVNode(_component_router_link, {
            to: link.url
          }, {
            default: _withCtx(() => [
              _createVNode(BaseTypography, {
                text: link.text,
                type: _unref(width) < 768 ? 'body-m' : 'footnote'
              }, null, 8, ["text", "type"])
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ]),
    (_unref(width) > 1024)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("img", {
          src: _imports_4,
          class: "w-[121px] m:w-auto",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openLinkInNewTab('https://tourligaspb.ru/team')))
        }),
        _hoisted_17
      ]),
      (_unref(width) < 1024)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_22))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(BaseTypography, {
          text: "ОГРН 1157847393373",
          type: _unref(width) < 1024 ? 'body-m' : 'footnote',
          color: "var(--grey-color)"
        }, null, 8, ["type"]),
        _createVNode(BaseTypography, {
          text: "ИНН 7840042552",
          type: _unref(width) < 1024 ? 'body-m' : 'footnote',
          color: "var(--grey-color)"
        }, null, 8, ["type"])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createVNode(BaseTypography, {
          text: `Copyright © Туроператор “РВМ”, ${_unref(currentYear)}`,
          type: _unref(width) < 1024 ? 'body-m' : 'footnote',
          color: "var(--grey-color)"
        }, null, 8, ["text", "type"])
      ]),
      (_unref(width) > 1024)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_30))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})